<template>
  <div v-if="modalNLSuccess" class="toggle-alert">
    <div class="-container">
      <div class="modal-content">
        <div class="">
          <div id="alert-modal" class="card bg-orange-gradLight">
            <button class="btn-close" @click="modalNLSuccessHandler">
              <img :src="close" alt="close" />
            </button>
            <div class="card-body">
              <div class="mensages-container">
                <img :src="success" alt="success" class="message-img" />

                <h1>subscrição efetuada com sucesso!</h1>
                <p>
                  Obrigado por subscreveres a nossa newsletter. Iremos manter-te
                  informado de todas as nossas novidades, promoções, notícias e
                  muito mais.
                </p>
                <div class="modal-bottom double">
                  <div class="text-center">
                    <button
                      class="btn-bg capitalize"
                      @click="modalNLSuccessHandler"
                    >
                      ok
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import icClose from "../../svg/ic_close_orange.svg";
import icSuccess from "../../svg/ic_success.svg";

export default {
  data() {
    return {
      close: icClose,
      success: icSuccess,
      modalNLSuccess: false,
    };
  },
  methods: {
    modalNLSuccessHandler() {
      this.modalNLSuccess = !this.modalNLSuccess;

      document.querySelector("html").classList.toggle("no-scroll");
      document.querySelector("body").classList.toggle("no-scroll");
    },
  },
  mounted() {
    window.addEventListener("showNewsletterSuccess", (event) => {
      if (window.dataLayer) {
        window.dataLayer.push({ event: "subscricao-newsletter" });
      }

      this.modalNLSuccessHandler();
    });
  },
};
</script>
